import { PolicyRequest } from '../policy-create';

export const POLICY_SEARCH = 'POLICY_SEARCH';
export const POLICY_SEARCH_SUCCESS = 'POLICY_SEARCH_SUCCESS';
export const POLICY_SEARCH_FAILED = 'POLICY_SEARCH_FAILED';
export const POLICY_SORT = 'POLICY_SORT';
export const PLAN_NAME = 'PLAN_NAME';
export const POLICY_SEARCH_RESET = 'POLICY_SEARCH_RESET';

export interface PolicySearchData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  policyNumber: string;
  referenceNumber: string;
  groupNumber: string;
  planCode: string;
  organizationCode: string;
  applicationDateTo: string;
  applicationDateFrom: string;
  startDateTo: string;
  startDateFrom: string;
  offset: number;
  limit: number;
}

export interface PolicySearchResponse {
  records: PolicyRequest[];
  total: number;
  offset: number;
  limit: number;
}

export interface PolicySearchGridSort {
  field: string;
  order: string;
}

export interface PolicySearchList {
  searchCriteria?: PolicySearchData;
  data?: PolicySearchResponse;
  searchFetched?: boolean;
  searchError?: unknown;
  sort?: PolicySearchGridSort;
  pageNumber: number;
  loading: boolean;
  planNames?: Record<string, string>;
}
